import { supabase } from './supabase';

export const initializeSpotify = (accessToken: string) => {
  // This function will be called after successful authentication
  // We'll implement this later when needed
};

export const connectSpotify = async () => {
  try {
    // Get current user's ID for state parameter
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    // Get the current session for the authorization header
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('No active session');

    // Initialize auth flow
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/spotify-auth`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to initialize Spotify authentication');
    }

    const { url } = await response.json();
    if (!url) {
      throw new Error('No authentication URL received');
    }

    // Redirect to Spotify auth URL
    window.location.href = url;
  } catch (error) {
    console.error('Error connecting to Spotify:', error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('An unexpected error occurred. Please try again.');
  }
};